import React from 'react';
import styled from 'styled-components';
import { Text, TextVariant } from '../../../text/index';
import { spacing } from '../../../theme/index';
import { Tooltip } from '../../../parts/index';
export const Title = ({ children, size = 'standard', toolTip, className }) => {
    return (<TitleWrap>
      <Text tag="h5" variant={size === 'standard' ? TextVariant.Small : TextVariant.ArticleTextHeader} style={{ margin: 0 }} className={className}>
        {children}
      </Text>
      {toolTip && <Tooltip text={toolTip}/>}
    </TitleWrap>);
};
export default Title;
const TitleWrap = styled.span `
  display: flex;
  position: relative;
  flex-basis: 100%;
  margin-bottom: ${spacing.space12};
`;
